import type { IconSvgObject } from './types';

const Gif02Icon: IconSvgObject = [
  ["path", { d: "M19 22H5C3.89543 22 3 21.1046 3 20L3 4C3 2.89543 3.89543 2 5 2H12L19 9V11M18.5 9H13.998C12.8935 9 11.998 8.10457 11.998 7V2.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21 14H18.5V16.5M18.5 16.5V19M18.5 16.5H20.5M13 14H14.5M14.5 14H16M14.5 14V19M13 19H14.5M14.5 19H16M10.5 15V14H7V19H10.5V17H9.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Gif02Icon;
